export var QsrLoginRoutes = {
    "/qsrlogin": {
        "name": "qsr-login",
        "loginScreen": true,
        "type": "frontend",
        "component": "qsrLoginContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["qsr_login"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./qsr-login.module.js");
                }
            }
        ]
    }
};